import { FC, useEffect, useState } from "react";
// import { ThemeButton } from "../../../components/button";
// import { InputGroup } from "../../../components/input-group";
// import { InputFlex } from "../../../components/styled-components/input-flex";
import { useHistory } from "react-router";
import { RadiologistStepContainer } from "../../../components/Radiologist/RadiologistStepContainer";

import { useFormik } from "formik";
// import { ValidateRadiologistRegisterForm } from "./validation";

import { ValidateRadiologistInviteForm } from "./validation";

// import { useRegisterRadiologistMutation } from "../../../services";
import { useRegisterRadiologistMutation } from "../../../services";
import toast from "react-hot-toast";
import { setCookie } from "../../../utils/cookies";
import { useDispatch } from "react-redux";
import {
  updateRadiologistProfile,
  updateRadiologistToken,
} from "../../../slices/radiologist-user";
// import { Link } from "react-router-dom";
// import { Checkbox } from "./../../../components/checkbox";
import { useQuery } from "../../hooks/use-query";
import { useGetDeptFromStore } from "../../../Hooks/get-user";
// import { ReactComponent as GoBack } from "./../../../assets/icons/back.svg";
import { RegisterStepOne } from "../../../components/Auth/RegisterStepOne";
import { EmailVerificationModal } from "../../../components/email-verification-modal/EmailVerificationModal";

const InviteRadiologist: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [register] = useRegisterRadiologistMutation();

  const [loading, setLoading] = useState<boolean>(false);
  // Track if terms was agreed or not
  // const [termsAgreed, setTermsAgreed] = useState<boolean>(false);
  const type = useQuery("type");
  const ref = useQuery("ref");
  const { userObject } = useGetDeptFromStore();

  const [emailSentModal, setEmailSentModal] = useState(false);
  const formik = useFormik<IFormikProps>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "radiologist",
      password: "",
      confirmPassword: "",

      // This is for adding the user to the department
      orgId: "",
      org: "",

      // This is for referral
      ref: "",
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (type === "add") {
        values.orgId = userObject.orgId;
        values.org = userObject.orgName;
        values.password = "Mobols*2000";
        values.confirmPassword = "Mobols*2000";
        // (values.password as any) = null;
        // (values.confirmPassword as any) = null;
      } else {
        delete values.orgId;
        delete values.org;
      }

      if (ref) {
        values.ref = ref;
      } else {
        delete values.ref;
      }

      try {
        const data = await register(values).unwrap();

        if (type === "add") {
          toast.success("Specialist added successfully", {
            position: "top-center",
            duration: 4_000,
          });
          // history.push(`radiology/radiologists?tab=Favourites`);
          ["firstName", "lastName", "email", "phoneNumber"].forEach((key) => {
            formik.setFieldValue(key, "");
            formik.setFieldTouched(key, false);
          });

          return;
        }

        // save user token to redux store
        dispatch(updateRadiologistToken(data.data?.token));
        // save user object to redux store
        dispatch(updateRadiologistProfile(data.data?.user));
        // Saves the user to cookies
        setCookie("gist", JSON.stringify(data.data));

        // history.push(`/radiologist/register/dep-1`);
        setEmailSentModal(true);

        toast.success("A verification link has been sent to your email", {
          duration: 8_000,
        });
      } catch (err: any) {
        console.log("err2", err);
        const message =
          (err?.data?.data && err?.data?.data[0]?.msg) ||
          err?.data?.message ||
          "An error occured while processing your request";
        console.log("messageerr", message);

        toast.error(message, {
          duration: 7_000,
        });
      } finally {
        setLoading(false);

        // TODO: This is a hack to set the password to Mobols*2000. Provide a better solution
        if (type === "add") {
          formik.setFieldValue("password", "Mobols*2000");
          formik.setFieldValue("confirmPassword", "Mobols*2000");
        }
      }
    },
    validationSchema: ValidateRadiologistInviteForm, 
  });
  const handleClose = () => {
    setEmailSentModal(false);
    history.push("/radiologist/register/dep-1");
  };

  useEffect(() => {
    if (type !== "add") return;

    // TODO: This is a hack to set the password to Mobols*2000. Provide a better solution
    formik.setFieldValue("password", "Mobols*2000");
    formik.setFieldValue("confirmPassword", "Mobols*2000");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RadiologistStepContainer showStep={false} step={0}>
      <RegisterStepOne
        path="user"
        formik={formik}
        loading={loading}
        // setLoading={setLoading}
      />

      <EmailVerificationModal
        path={"user"}
        email={formik.values.email}
        modalOpen={emailSentModal}
        handleClose={handleClose}
      />
    </RadiologistStepContainer>
  );
};

export default InviteRadiologist;

interface IFormikProps {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: "radiologist";
  password: string;
  confirmPassword: string;

  // This is for adding the user to the department
  orgId?: string;
  org?: string;

  // This is for referral
  ref?: string;
}